import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[appWidgetEditor]'
})
export class WidgetEditorDirective {
  constructor(public viewContainerRef: ViewContainerRef) { }
}
